import React, { FC } from "react";
import { TreatmentsContainerDoctor } from "./TreatmentsContainerDoctor.csharp";

export const DoctorsContainerCard: FC<TreatmentsContainerDoctor> = ({
  fullName,
  url,
  imageUrl,
  jobTitle,
}) => {
  return (
    <div className="card card-hover theme-inherit-medium mb-1">
      <div className="card-body">
        <div className="d-flex">
          <img className="circular-image medium me-2" src={imageUrl+'?width=216&height=216&rmode=crop&ranchor=top'} loading="lazy" />
          <div className="lh-sm">
            <p className="fw-bold mb-0"><a className="card-block-link" href={url}>{fullName}</a></p>
            {jobTitle && <p className="fs-5 pt-2 mb-0 text-break" dangerouslySetInnerHTML={{__html: jobTitle}}/>}
          </div>
        </div>
      </div>
    </div>
  );
};
